import React from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import useIsMobile from 'lib/useIsMobile';
import { useMediaQuery } from 'react-responsive';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import comingsoon from 'assets/comingsoon.png';

const styles = {
  listStyle: {
    width: '45%',
    display: 'inline-block',
    marginBottom: '5%',
    marginRight: '3%',
    float: 'right',
  },
  listStyleMobile: {
    width: '100%',
    display: 'inline-block',
    marginBottom: '0%',
    marginRight: '3%',
    marginTop: '0%',
    paddingRight: '4%',
    paddingLeft: '4%',
  },
  listHeader: {
    border: '1px solid #ACACAC',
    borderRadius: '15px 15px 0px 0px',
    color: '#898989',
    fontWeight: '700',
    fontSize: '1.5vw',
    backgroundColor: '#FFFFFF',
    marginTop: 25,
    zIndex: 2,
    top: 20,
    borderBottom: 'none',
  },
  listHeaderMobile: {
    border: '1px solid #ACACAC',
    borderRadius: '15px 15px 0px 0px',
    color: '#898989',
    fontWeight: '700',
    fontSize: '14px',
    backgroundColor: '#FFFFFF',
    marginTop: 25,
    zIndex: 2,
    top: 20,
    borderBottom: 'none',
  },
  score: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: '30px',
    textAlign: 'center',
    position: 'relative',
    top: '27%',
  },
  scoreMobile: {
    color: '#FFFFFF',
    fontWeight: '700',
    fontSize: '20px',
    textAlign: 'center',
    position: 'relative',
    top: '27%',
  },
  whatIsThis: {
    border: '1px solid #ACACAC',
    borderRadius: '10px',
    color: '#898989',
    width: '35%',
    height: '60px',
    fontWeight: '700',
    fontSize: '14px',
    textAlign: 'center',
    cursor: 'pointer',
    // display: 'inline-block',
    float: 'left',
    marginRight: '5%',
    boxShadow: '30px 0px #F5F5F5 inset',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  whatIsThisMobile: {
    border: '1px solid #ACACAC',
    borderRadius: '10px',
    color: '#898989',
    width: '40%',
    height: '40px',
    fontWeight: '700',
    fontSize: '14px',
    textAlign: 'center',
    cursor: 'pointer',
    // display: 'inline-block',
    float: 'left',
    marginRight: '3%',
    boxShadow: '30px 0px #F5F5F5 inset',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  noActivities: {
    border: '1px solid #ACACAC',
    borderRadius: '10px',
    background: '#F5F5F5',
    color: '#424242',
    width: '56%',
    height: '60px',
    fontWeight: '400',
    fontSize: '14px',
    textAlign: 'center',
    // display: 'inline-block',
    float: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  purpleCurve: {
    position: 'absolute',
    top: '29%',
    left: '78%',
    transform: 'translate(-50%, -50%)',
    height: '70px',
    width: '120px',
    borderRadius: '150px 150px 0 0',
    backgroundColor: '#898989',
    textAlign: 'center',
  },
  purpleCurveMobile: {
    position: 'absolute',
    top: '43%',
    left: '78%',
    transform: 'translate(-50%, -50%)',
    height: '55px',
    width: '95px',
    borderRadius: '150px 150px 0 0',
    backgroundColor: '#898989',
    textAlign: 'center',
  },
};

const DashboardListWalletFadeout = () => {
  const mobile = useIsMobile();
  const tablet = useMediaQuery({ maxWidth: 960 });

  const renderList = () => {
    return (
      <List
        aria-labelledby='nested-list-subheader'
        subheader={(
          <ListSubheader
            style={
              mobile || tablet ? styles.listHeaderMobile : styles.listHeader
            }
            component='div'
            id='nested-list-subheader'
          >
            <div
              style={{
                width: '96px',
                height: '20px',
                background: '#898989',
                position: 'absolute',
                top: '-13px',
              }}
            >
              <img
                alt='beta'
                src={comingsoon}
                style={{
                  width: '88px',
                  height: '20px',
                  position: 'absolute',
                  left: '5%',
                }}
              />
            </div>
            My Wallet
            <div
              style={
                mobile || tablet ? styles.purpleCurveMobile : styles.purpleCurve
              }
            >
              <span
                style={mobile || tablet ? styles.scoreMobile : styles.score}
              >
                $0.00
              </span>
            </div>
          </ListSubheader>
        )}
        style={mobile || tablet ? styles.listStyleMobile : styles.listStyle}
      >
        <ListItem
          style={{
            border: '1px solid #ACACAC',
            borderRadius: '0px 0px 15px 15px',
            borderTop: 'none',
            paddingTop: '0px',
          }}
        >
          <ListItemText style={{ marginTop: '0px' }}>
            <div
              style={
                mobile || tablet ? styles.whatIsThisMobile : styles.whatIsThis
              }
            >
              <InfoOutlinedIcon />
              <span
                style={
                  {
                    // position: 'relative',
                    // top: mobile || tablet ? '15%' : '31%',
                  }
                }
              >
                What is this?
              </span>
            </div>
            <div style={styles.noActivities}>
              <span>You Currently Have No Cash in Your Wallet</span>
            </div>
          </ListItemText>
        </ListItem>
      </List>
    );
  };
  return <>{renderList()}</>;
};

export default DashboardListWalletFadeout;
